export enum Platform {
  ELLOS = 1
}
